import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {lastValueFrom, Subject} from 'rxjs';
import {takeUntil} from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {WindowRefService} from "../../helpers/windowref.service";
import translation from "../../google-coupon/google-coupon-step1/messageTranslation.json";
import {MessageService} from 'primeng/api';
import { ConfigService } from '../../helpers/config.service';
import { DataServiceService } from '../../helpers/data.service';
import {ApiCallService} from "../../helpers/api-call.service";
import {NavigationService} from "../../helpers/navigation.service";

@Component({
    selector: 'app-youtube-coupon-step2',
    templateUrl: './youtube-coupon-step2.component.html',
    styleUrl: './youtube-coupon-step2.component.scss',
    standalone: false
})

export class YoutubeCouponStep2Component implements OnInit, OnDestroy {
  componentDestroyed: Subject<boolean> = new Subject();
  currentYear: number = new Date().getFullYear();
  loading: boolean = false;
  geo: string = 'Global';
  openTabIndex:any = undefined;
  metricData:any = {
    link: {
      amount: '3,000',
      text: 'Accounts Linked',
    },
    redeemed: {
      amount: '2,250',
      text: 'Coupons Redeemed',
    },
    saved: {
      amount: '$955,000',
      text: 'Saved',
    }
  };
  csData:any = {};
  showCsData:boolean = true;
  page = "youtube"
  constructor(private router: Router, private http: HttpClient,  private winRef: WindowRefService,
              private messageService: MessageService, public data:DataServiceService, public cs: ConfigService,
              private apiCallService: ApiCallService, private navigationService: NavigationService,) {
                this.data.setHeaderMenuSelection('10');
              }

  ngOnInit(): void {
    this.navigationService.canNavigateToStep3Youtube = false;
    this.winRef.reportGtagEventNew('pageViewStep2');
    document.body.scrollTop = 0;
    this.getCsData();
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(true);
    this.componentDestroyed.complete();
  }

  async getCsData(): Promise<void> {
    this.csData = {};
    this.showCsData = true;
    await this.cs.getConfigurations('youtube', 'en');
    this.data.setCsObj(this.cs);
    this.csData = this.cs;
    setTimeout(() => {
        this.showCsData = false;
    }, 100);
  }

  goToEligibleLink(channel:string) {
    this.data.goToEligibleLink(channel);
   }
   
  changeSelectedTabIndex(e:any) {
    if (e) {
      this.openTabIndex =e.index;
    }
  }

  async RedeemCoupon() {
    const info = sessionStorage.getItem('youtubeInfo');
    const sessionToken = sessionStorage.getItem('youtubeToken');
    const passedList = sessionStorage.getItem("youtubePassedList")
    if (info && sessionToken && passedList) {
      const infoJson = JSON.parse(info);
      const refreshToken = infoJson.refresh_token;
      const managerLinks = JSON.parse(passedList);
      if (refreshToken && managerLinks && managerLinks.length) {
        this.loading = true;
        const params = {
          refresh_token: refreshToken,
          manager_links: managerLinks,
          session_token: sessionToken,
          geo: this.geo,
          utm_source: infoJson.utm_source,
          utm_medium: infoJson.utm_medium,
          page:this.page
        };
        const accept$ = this.apiCallService.accept(params, 'google');
        const response = await lastValueFrom(accept$);
        this.loading = false;
        if (response && response.result == 'success'){
          sessionStorage.removeItem("youtubeInfo");
          sessionStorage.removeItem("youtubeToken");
          sessionStorage.removeItem('youtubePassedList');
          this.navigationService.canNavigateToStep3Youtube = true;
          this.router.navigate(['/yt/step3']);
        } else {
          let error = response.error;
          let severity = error.severity;
          let summary = 'We apologize for the inconvenience.';
          if (severity === 'success') {
            summary = 'Great news!';
          }
          if (severity === 'warn') {
            summary = '';
          }
          this.messageService.add({
            key: 'msgTemplate',
            severity: severity,
            summary: summary,
            detail: error.info,
            data:translation[error.info as keyof typeof translation],
            closable: true,
            sticky: true
          });
        }
      }
    }
  }

  got_it(): void {
    this.navigationService.canNavigateToStep3Youtube = true;
    this.router.navigate(['/yt/step3'], { queryParams: { action: 'link' } });
  }

}
